import { Types as TypesIndiciacao } from '../indicacao/actions';
import { Types as TypesPerguntas } from '../perguntas/actions';
import { Types as TypesCategorias } from '../categorias/actions';
import { Types as TypesProdutos } from '../produtos/actions';

export const INITIAL_STATE = {
  code: null,
};

export default function errors(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case TypesIndiciacao.SEARCH_CNPJ:
    case TypesIndiciacao.SEARCH_ENDERECO:
    case TypesPerguntas.REQUEST: {
      return { ...state, code: null };
    }
    case TypesCategorias.FAILURE: {
      return { ...state, code: 400 };
    }
    case TypesProdutos.FAILURE: {
      return { ...state, code: 400 };
    }
    case TypesPerguntas.FAILURE: {
      return { ...state, code: 400 };
    }
    default:
      return state;
  }
}
